// removed by extract-text-webpack-plugin
module.exports = {"black":"#000000","light-grey":"#d4d4d4","grey":"#707070","bilableMenu":"_2RjcEICf40PaN_jOL7Ud0L","separator":"_2gMR1cwjmYowNpmrFqgj79","title":"_1vg2-rkYZDdNiKMM-0oYQy","dropdown":"_1tbwUzHenpK_Gdblfub9ok"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Header/BillableId/BillableId.css
// module id = 1339
// module chunks = 0